/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import AddOrUpdateModel from "../GenericComponents/AddOrUpdateModel";
import { Vocabulary } from "../../Utils/Vocabulary";
import { CustomerTypeModel } from "../../Utils/Models";
import { postData } from "../../Services/postData";
import { urlEnum } from "../../Utils/UrlEnum";
import { toast } from "react-toastify";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";

type CategoryProps = {
  open: boolean;
  shouldUpdate: boolean;
  onClose: () => void;
};

export default function CustomerType(props: CategoryProps) {
  const { open, onClose, shouldUpdate } = props;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ref: any = useRef();
  const [pressOnSubmit, setPressOnSubmit] = useState(false);

  // Initialize customerType with isPositive true by default
  const [customerType, setCsutomerType] = useState<CustomerTypeModel>(() => {
    const model = new CustomerTypeModel();
    model.isPositive = true;
    return model;
  });

  useEffect(() => {
    if (pressOnSubmit) {
      ref.current.submit();
      // reset the value
      handleChangePressOnSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pressOnSubmit]);

  const addOrUpdateCustomerType = async (customerType: CustomerTypeModel) => {
    if (!shouldUpdate) {
      const reqUrl = `${urlEnum.customerCrm}/type`;
      postData(reqUrl, customerType)
        .then(() => {
          toast.success("Type created");
          onClose();
        })
        .catch(() => {
          toast.error("Error on type creation");
        });
    }
  };

  function handleChangePressOnSubmit() {
    setPressOnSubmit(!pressOnSubmit);
  }

  return (
    <ValidatorForm
      ref={ref}
      onSubmit={() => addOrUpdateCustomerType(customerType)}
    >
      <AddOrUpdateModel
        open={open}
        title={Vocabulary.category}
        onClose={onClose}
        isSubmit={true}
        addOrUpdateItem={() => null}
        handleChangePressOnSubmit={handleChangePressOnSubmit}
      >
        <Grid container spacing={2} style={{ marginTop: 10 }}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <TextValidator
              size="small"
              label={Vocabulary.name}
              name="name"
              value={customerType.name}
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              onChange={(e: any) =>
                setCsutomerType({ ...customerType, name: e.target.value })
              }
              validators={["required"]}
              errorMessages={[Vocabulary.requiredField]}
              style={{ marginBottom: 20 }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <FormControl>
              <FormLabel>{Vocabulary.discountType}</FormLabel>
              <RadioGroup
                value={
                  customerType.isPositive
                    ? Vocabulary.positive
                    : Vocabulary.negative
                }
                onChange={(event: any) => {
                  setCsutomerType({
                    ...customerType,
                    isPositive: event.target.value === Vocabulary.positive,
                  });
                }}
              >
                <FormControlLabel
                  value={Vocabulary.positive}
                  control={<Radio />}
                  label={Vocabulary.positive}
                />
                <FormControlLabel
                  value={Vocabulary.negative}
                  control={<Radio />}
                  label={Vocabulary.negative}
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextValidator
              size="small"
              type="number"
              label={Vocabulary.discount}
              name="discountAmmount"
              value={customerType.discountAmmount}
              onChange={(event: any) => {
                setCsutomerType({
                  ...customerType,
                  discountAmmount: +event.target.value,
                });
              }}
              style={{ marginBottom: 20 }}
              fullWidth
            />
          </Grid>
        </Grid>
      </AddOrUpdateModel>
    </ValidatorForm>
  );
}
